/**
 * The Ctrl+K command palette, and how we advertise it.
 *
 * A shortcut nobody knows about is a shortcut nobody uses, so the hint is shown
 * in two places that catch two different moments: a badge inside the header
 * search box (where you look when you *want* to search) and a line at the foot
 * of the sidebar (where you look when you're browsing and haven't formed an
 * intent yet). Both render the same label from here so they can't drift, and
 * both can open the palette directly.
 */

/** Mac reports "MacIntel"/"Mac68K"/etc; the modifier key differs, so the hint must too. */
const isMac = typeof navigator !== "undefined"
    && /mac/i.test((navigator as any).userAgentData?.platform ?? navigator.platform ?? "");

/** "⌘ K" on Mac, "Ctrl K" everywhere else. */
export const COMMAND_PALETTE_KEYS: string[] = isMac ? ["⌘", "K"] : ["Ctrl", "K"];

/** Single-string form, for tooltips and aria-labels. */
export const COMMAND_PALETTE_HINT = COMMAND_PALETTE_KEYS.join(" ");

/**
 * The event the palette listens for. Anything that wants to open the palette
 * dispatches this rather than reaching into its state — the palette is mounted
 * once in DefaultLayout and has no shared context.
 */
export const OPEN_COMMAND_PALETTE_EVENT = "crx:open-command-palette";

/** Open the command palette from anywhere (a hint badge, a button, a menu item). */
export const openCommandPalette = (): void => {
    window.dispatchEvent(new CustomEvent(OPEN_COMMAND_PALETTE_EVENT));
};
